"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MobileView = _interopRequireDefault(require("../../elements/view/MobileView"));

var _DesktopTabletView = _interopRequireDefault(require("../../elements/view/DesktopTabletView"));

var _NavHamburger = _interopRequireDefault(require("../elements/NavHamburger"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactstrap = require("reactstrap");

var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));

var _Theme = _interopRequireDefault(require("../../themes/Theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var HorizontalNavHolder = _styledComponents["default"].div.withConfig({
  displayName: "HorizontalBarForVerticalNav__HorizontalNavHolder",
  componentId: "sc-1shf6aj-0"
})(["&&&{z-index:1051;position:absolute;left:0;width:72px;@media (min-width:768px){top:22px;}@media (max-width:767px){top:0px;}}"]);

var NavContainer = _styledComponents["default"].div.withConfig({
  displayName: "HorizontalBarForVerticalNav__NavContainer",
  componentId: "sc-1shf6aj-1"
})(["&&&{background-color:white;width:100vw;height:100%;box-shadow:0 2px 6px 0 rgba(0,0,0,0.1);}"]);

var LogoHolder = _styledComponents["default"].div.withConfig({
  displayName: "HorizontalBarForVerticalNav__LogoHolder",
  componentId: "sc-1shf6aj-2"
})(["&&&{z-index:1052;float:left;}"]);

var LogoLink = (0, _styledComponents["default"])(_reactRouterDom.Link).withConfig({
  displayName: "HorizontalBarForVerticalNav__LogoLink",
  componentId: "sc-1shf6aj-3"
})(["&&&{padding:0;}"]);

var Title = _styledComponents["default"].div.withConfig({
  displayName: "HorizontalBarForVerticalNav__Title",
  componentId: "sc-1shf6aj-4"
})(["&&&{@media (min-width:768px){font-size:1.55rem;}@media (max-width:767px){font-size:18px;margin-top:5px;}}color:", ";font-weight:bold;"], function (props) {
  return props.color;
});

var LogoPaddingStyle = _styledComponents["default"].div.withConfig({
  displayName: "HorizontalBarForVerticalNav__LogoPaddingStyle",
  componentId: "sc-1shf6aj-5"
})(["&&&{@media (min-width:768px){padding-right:15px;}@media (max-width:767px){padding-right:5px;}}"]);

var StyledChildren = _styledComponents["default"].div.attrs(function () {
  return {
    className: "ml-auto"
  };
}).withConfig({
  displayName: "HorizontalBarForVerticalNav__StyledChildren",
  componentId: "sc-1shf6aj-6"
})(["&&&{@media (max-width:767px){margin-bottom:5px;}}"]);

var NavIconHolder = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex align-items-center justify-content-center"
  };
}).withConfig({
  displayName: "HorizontalBarForVerticalNav__NavIconHolder",
  componentId: "sc-1shf6aj-7"
})(["height:", "px;width:", "px;"], function (props) {
  return props.height;
}, function (props) {
  return props.width;
});

var NavLogo = function NavLogo(_ref) {
  var logo = _ref.logo,
      height = _ref.height,
      width = _ref.width;
  return _react["default"].createElement("div", null, logo ? _react["default"].createElement(NavLogo, {
    src: logo,
    imageHeight: height,
    width: width
  }) : _react["default"].createElement(NavIconHolder, {
    height: height,
    width: width
  }, _react["default"].createElement(_Icon["default"], {
    iconName: "fa-baseball-ball",
    styles: {
      color: _Theme["default"]["mlb-blue"],
      hoverColor: _Theme["default"]["mlb-blue"]
    }
  })));
};

var HorizontalBarForVerticalNav = function HorizontalBarForVerticalNav(_ref2) {
  var children = _ref2.children,
      title = _ref2.title,
      loggedIn = _ref2.loggedIn,
      mobileNavOpen = _ref2.mobileNavOpen,
      toggleMobileNav = _ref2.toggleMobileNav,
      logo = _ref2.logo,
      builds = _ref2.builds;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      tooltipOpen = _useState2[0],
      setTooltipOpen = _useState2[1];

  var toggle = function toggle() {
    setTooltipOpen(!tooltipOpen);
  };

  return loggedIn && _react["default"].createElement(HorizontalNavHolder, null, _react["default"].createElement(LogoHolder, null, _react["default"].createElement(LogoLink, {
    to: "/"
  }, _react["default"].createElement(LogoPaddingStyle, null, _react["default"].createElement("div", {
    id: "TooltipTarget"
  }, _react["default"].createElement(_MobileView["default"], null, _react["default"].createElement(NavLogo, {
    logo: logo,
    height: 32,
    width: 30
  })), _react["default"].createElement(_DesktopTabletView["default"], null, _react["default"].createElement(NavLogo, {
    logo: logo,
    height: 37,
    width: 68
  })))))), builds.length ? _react["default"].createElement(_reactstrap.Tooltip, {
    placement: "bottom",
    isOpen: tooltipOpen,
    target: "TooltipTarget",
    toggle: toggle,
    delay: {
      show: 1000,
      hide: 500
    }
  }, _react["default"].createElement("div", {
    className: "p-1"
  }, _react["default"].createElement("div", null, "Versions"), _react["default"].createElement("div", null, builds.map(function (b) {
    return _react["default"].createElement("div", {
      key: b.name
    }, b.name, ": ", b.build);
  })))) : null, _react["default"].createElement(NavContainer, null, _react["default"].createElement("div", {
    className: "d-flex align-self-center"
  }, _react["default"].createElement(Title, {
    color: "#041e42"
  }, title), _react["default"].createElement(StyledChildren, null, children), _react["default"].createElement(_MobileView["default"], null, loggedIn ? _react["default"].createElement(_NavHamburger["default"], {
    open: mobileNavOpen,
    toggle: toggleMobileNav,
    color: "#041e42"
  }) : null))));
};

HorizontalBarForVerticalNav.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  title: _propTypes["default"].string
};
HorizontalBarForVerticalNav.defaultProps = {
  title: "Welcome"
};
var _default = HorizontalBarForVerticalNav;
exports["default"] = _default;